import { getValue } from './getValue';
import { hasByType } from './hasByType';
import { IJQDescription, IJsonQuery, IPolygonItem } from '../../types/interfaces';

export function isDescriptorActive(descriptor: { form: IJQDescription[] }) {
  return (jsonQuery: IJsonQuery) =>
    descriptor.form.every(({ key, value, type }) =>
      jsonQuery[key]
        ? // oxlint-disable-next-line typescript/no-non-null-assertion
          hasByType<number | string | boolean | IPolygonItem>(type, jsonQuery[key]!, getValue(value, jsonQuery))
        : false,
    );
}
